export const ALLOWED_MESSAGE_TYPES = [
  'LEASE',
  'FINANCE',
  'NEW_VEHICLE',
  'USED_VEHICLE',
  'CPO',
] as const;

export const FIELD_NAME_ENUM = [
  'voi_model',
  'New_Auto_Class',
  'CATCHALL',
] as const;

/** CATCHALL is a standalone field condition — no Field Value is required. */
export const CATCHALL_FIELD_NAME = 'CATCHALL' as const;

export function isCatchallFieldName(fieldName: string | null | undefined): boolean {
  return (fieldName ?? '').trim().toUpperCase() === CATCHALL_FIELD_NAME;
}

